import { MenuItemType, MenuDataForRole } from "./menuItem";

export enum AppUserRoles {
  SystemAdmin = "SystemAdmin",
  SuperAdmin = "SuperAdmin",
  Admin = "Admin",
  User = "User",
}

export const SystemAdminItems: MenuItemType[] = [
  {
    displayName: "Super Admin",
    id: "superAdmin",
    children: [
      { displayName: "List", id: "superAdminList" },
      { displayName: "Add", id: "superAdminCreate" },
    ],
  },
  {
    displayName: "Black List Email",
    id: "blackListEmail",
    children: [
      { displayName: "List", id: "blackListEmailList" },
      { displayName: "Add", id: "blackListEmailCreate" },
    ],
  },
 
];

export const SuperAdminItems: MenuItemType[] = [
  {
    displayName: "Super Admin",
    id: "superAdmin",
    children: [
      { displayName: "List", id: "superAdminList" },
      { displayName: "Add", id: "superAdminCreate" },
    ],
  },
  {
    displayName: "Admins",
    id: "admins",
    children: [
      { displayName: "List", id: "adminsList" },
      { displayName: "Add", id: "adminsCreate" },
    ],
  },
  {
    displayName: "Users",
    id: "users",
    children: [
      { displayName: "List", id: "usersList" },
      { displayName: "Add", id: "usersCreate" },
    ],
  },
  {
    displayName: "User Log",
    id: "userLog",
  },
];

export const AdminItems: MenuItemType[] = [
  {
    displayName: "Admins",
    id: "admins",
    children: [
      { displayName: "List", id: "adminsList" },
      { displayName: "Add", id: "adminsCreate" },
    ],
  },
  {
    displayName: "Users",
    id: "users",
    children: [
      { displayName: "List", id: "usersList" },
      { displayName: "Add", id: "usersCreate" },
    ],
  },
  {
    displayName: "User Log",
    id: "userLog",
  },
];



export const MenuData: MenuDataForRole = {
  [AppUserRoles.SystemAdmin as string] : SystemAdminItems,
  [AppUserRoles.SuperAdmin as string]: SuperAdminItems,
  [AppUserRoles.Admin as string]: AdminItems,
};

